import { Loader2 } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";

import { BrandArrow } from "@/components/brand-arrow";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useTracks } from "@/lib/api";

import { TrackFormDialog } from "./track-form-dialog";
import { TrackTable } from "./track-table";

export function AdminTracksPage() {
  const tracksQuery = useTracks();
  const [createOpen, setCreateOpen] = useState(false);

  const tracks = tracksQuery.data ?? [];

  return (
    <div className="bg-background min-h-screen">
      <header className="border-border flex items-center justify-between border-b px-6 py-4">
        <h1 className="text-foreground text-xl">Track management</h1>
        <div className="flex items-center gap-2">
          <Link to="/dashboard">
            <Button variant="ghost">Dashboard</Button>
          </Link>
          <Link to="/home">
            <Button variant="outline">Back</Button>
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">
        {tracksQuery.isLoading ? (
          <Card>
            <CardContent className="flex justify-center py-12">
              <Loader2 className="text-muted-foreground h-6 w-6 animate-spin" />
            </CardContent>
          </Card>
        ) : tracksQuery.isError ? (
          <Card>
            <CardContent className="py-8 text-center">
              <p className="text-muted-foreground text-sm">
                Could not load tracks. Please{" "}
                <button
                  type="button"
                  onClick={() => void tracksQuery.refetch()}
                  className="underline"
                >
                  try again
                </button>{" "}
                or{" "}
                <Link to="/home" className="underline">
                  go back
                </Link>
                .
              </p>
            </CardContent>
          </Card>
        ) : (
          <>
            <div className="mb-6 flex justify-end">
              <Button onClick={() => setCreateOpen(true)}>
                New track
                <BrandArrow />
              </Button>
            </div>
            <TrackTable tracks={tracks} />
            <TrackFormDialog track={null} open={createOpen} onOpenChange={setCreateOpen} />
          </>
        )}
      </main>
    </div>
  );
}
